module.exports = __webpack_public_path__ + "static/img/2117_phase_function_Paper_Points.35e0d48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2117_phase_function_Paper_Points.png
// module id = 6Njp
// module chunks = 0